module.exports = __webpack_public_path__ + "img/product-shot_02_loading.c7730522.jpg";